import React from 'react';
import { DialogUI } from '../../Interface';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { IconButton } from '@mui/material';

const OpWidgetReasonDialog = ({
  open,
  handleClose,
  data,
  handleStopOperation,
  setSelectedReasonCode,
  setIsQuantityDialogOpen,
  setShowConfirmDialog,
  isGrouped,
  handleInterruptOperation,
  mode,
  setIsGrouppedDialogOpen,
}) => {
  const handleClick = (code) => {
    if (mode === 'downtime') {
      handleStopOperation(null, code);
    } else if (mode === 'interrupt' && isGrouped) {
      setSelectedReasonCode(code);
      handleClose();
      setShowConfirmDialog(false);
      setIsGrouppedDialogOpen(true);
    } else {
      setSelectedReasonCode(code);
      handleClose();
      setIsQuantityDialogOpen(true);
      setShowConfirmDialog(false);
    }
  };

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent="Ok kiválasztása"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '1300px',
          },
        },
      }}
    >
      <div className="pb-5 px-3 flex gap-5">
        <IconButton size="small" onClick={handleClose}>
          <div className="text-sm font-medium py-2 px-3 rounded flex items-center justify-center gap-1 bg-ganttHoverButtonColor text-white mt-2">
            <KeyboardBackspaceIcon sx={{ fontSize: '2rem' }} />
            <span className="text-2xl">Vissza</span>
          </div>
        </IconButton>
      </div>
      <div className="flex justify-center gap-10 flex-wrap">
        {data.length > 0 &&
          data.map((item) => (
            <div
              key={item.code}
              className="h-[200px] w-[220px] bg-[#6f9ad833] text-[#014AB1] hover:bg-[#6f9ad880] rounded-lg flex items-center justify-center text-3xl cursor-pointer"
              onClick={() => handleClick(item.code)}
            >
              {item.name}
            </div>
          ))}
      </div>
    </DialogUI>
  );
};

export default OpWidgetReasonDialog;
